import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
    const [params] = useSearchParams();
    const bookingId = params.get("booking_id");
    return (
        <div data-testid="payment-cancel-page" className="pt-32 pb-20 min-h-screen">
            <div className="container-vv max-w-2xl">
                <div className="card-luxe text-center">
                    <div className="h-20 w-20 rounded-full bg-destructive/20 grid place-items-center mx-auto mb-6">
                        <XCircle className="h-10 w-10 text-destructive" />
                    </div>
                    <h1 className="font-serif text-3xl text-cream">Payment Cancelled</h1>
                    <p className="mt-4 text-cream-muted">No worries — your slot is still held briefly. Try again whenever you're ready.</p>
                    <div className="mt-8 flex justify-center gap-4">
                        <Link to="/" className="btn-outline-gold text-sm"><ArrowLeft className="h-4 w-4" /> Home</Link>
                        <Link to={bookingId ? `/booking` : "/booking"} className="btn-gold text-sm" data-testid="retry-booking-btn">Try Again</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
